import { createFileRoute } from '@tanstack/react-router';

import UserPage from '~/app/users/UserPage';

export const Route = createFileRoute('/_app/home/users/$actorId')({
	beforeLoad: () => {
		return {
			getTitle: 'Details'
		};
	},
	component: UserPage
});
